import type { DoctorListItem } from '@dermalink/shared';
import { DoctorAvatar } from './DoctorAvatar.tsx';
import styles from './DoctorCard.module.css';

interface Props {
  doctor: DoctorListItem;
  onSelect: (id: string) => void;
  /** Key passed to onSelect — defaults to cognito_sub (patient flow), pass 'riziv_number' for RIZIV self-identification flow. */
  selectKey?: 'cognito_sub' | 'riziv_number';
  disabled?: boolean;
  buttonLabel?: string;
  /** Highlights the card when this doctor is selected (patient flow). */
  selected?: boolean;
}

export function DoctorCard({
  doctor,
  onSelect,
  selectKey = 'cognito_sub',
  disabled = false,
  buttonLabel = 'Selecteer',
  selected = false,
}: Props) {
  const id = selectKey === 'riziv_number' ? (doctor.riziv_number ?? doctor.cognito_sub) : doctor.cognito_sub;
  const qualification = doctor.riziv_qualification ?? 'Dermatoloog';
  const subtitle = doctor.organization_name ? `${doctor.organization_name}` : qualification;

  const unavailable = doctor.is_available === false;

  return (
    <button
      type="button"
      className={`${styles.card}${selected ? ` ${styles.cardSelected}` : ''}`}
      onClick={() => onSelect(id)}
      disabled={disabled || unavailable}
      aria-label={`${buttonLabel} Dr. ${doctor.first_name ?? ''} ${doctor.last_name ?? ''}`.trim()}
    >
      <DoctorAvatar doctor={doctor} circleClassName={styles.avatar} imageClassName={styles.avatarImage} />
      <span className={styles.main}>
        <span className={styles.name}>Dr. {doctor.first_name} {doctor.last_name}</span>
        <span className={styles.subtitle}>{subtitle}</span>
        {unavailable && <span className={styles.unavailablePill}>Niet beschikbaar</span>}
      </span>
      <span className={styles.arrow} aria-hidden="true">›</span>
    </button>
  );
}
